const branch = {
  modalSetISO: {
    title: 'Confirm Set ISO Item',
    message: 'Are you sure want to set items as ISO item?'
  },
  modalUnsetISO: {
    title: 'Confirm Unset ISO Item',
    message: 'Are you sure want to unset items as ISO item?'
  },
  modalSetReference: {
    title: 'Confirm Set Reference Item',
    message: 'Are you sure want to set items as Reference item?'
  },
  modalUnsetReference: {
    title: 'Confirm Unset Reference Item',
    message: 'Are you sure want to unset items as Reference item?'
  },
  branchManager: 'Branch Manager',
  selectBranchManager: 'Select Branch Manager',
  regional: 'Regional',
  selectRegional: 'Select Regional'
}

export default branch
